import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75c39017"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "customer-details__details-container" }
const _hoisted_3 = { class: "customer-details__title" }
const _hoisted_4 = {
  key: 0,
  class: "customer-details__text"
}
const _hoisted_5 = {
  key: 1,
  class: "customer-details__text"
}
const _hoisted_6 = {
  key: 2,
  class: "customer-details__text"
}
const _hoisted_7 = {
  key: 3,
  class: "customer-details__text"
}
const _hoisted_8 = {
  key: 4,
  class: "customer-details__text"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = {
  key: 5,
  class: "customer-details__text"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = {
  key: 6,
  class: "customer-details__text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_form = _resolveComponent("v-form")!

  return (_ctx.customer)
    ? (_openBlock(), _createBlock(_component_v_form, {
        key: 0,
        onSubmit: _ctx.onSubmit,
        class: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1),
              (_ctx.companyType === 'Avtal' && _ctx.shipTo)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.companyName), 1))
                : (_ctx.companyType !== 'Avtal' && !_ctx.shipTo)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.customer.company && _ctx.customer.company.name), 1))
                  : _createCommentVNode("", true),
              (_ctx.companyType === 'Avtal' && _ctx.shipTo)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6))
                : (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.customer.firstName) + " " + _toDisplayString(_ctx.customer.lastName), 1)),
              (_ctx.shipTo)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                    (_ctx.customer.company && _ctx.customer.company.deliveryAddresses.length == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                          _createTextVNode(_toDisplayString(_ctx.customer.company.deliveryAddresses[0].line1 ?? ""), 1),
                          _hoisted_10,
                          _createTextVNode(" " + _toDisplayString(_ctx.customer.company.deliveryAddresses[0].zip ?? "") + " " + _toDisplayString(_ctx.customer.company.deliveryAddresses[0].city ?? ""), 1),
                          _hoisted_11,
                          _createTextVNode(" " + _toDisplayString(_ctx.customer.company.deliveryAddresses[0].country ?? ""), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createTextVNode(_toDisplayString(_ctx.customer.deliveryAddresses[0].line1 ?? ""), 1),
                          _hoisted_13,
                          _createTextVNode(" " + _toDisplayString(_ctx.customer.deliveryAddresses[0].zip ?? "") + " " + _toDisplayString(_ctx.customer.deliveryAddresses[0].city ?? ""), 1),
                          _hoisted_14,
                          _createTextVNode(" " + _toDisplayString(_ctx.customer.deliveryAddresses[0].country ?? ""), 1)
                        ]))
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.shipTo)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                    _createTextVNode(_toDisplayString(_ctx.customer.email), 1),
                    _hoisted_16,
                    _createTextVNode(_toDisplayString(_ctx.customer.mobilePhone), 1)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.hideData)
                ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.customer.deliveryInformation), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"]))
    : _createCommentVNode("", true)
}